export default function IconClose(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 40 40" fill="none" {...props}>
            <rect width="40" height="40" rx="20" fill="#F4F4F4" />
            <path d="M27.5 27.5L12.5 12.5" stroke="#707070" strokeWidth="3.64072" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M27.5 12.5L12.5 27.5" stroke="#707070" strokeWidth="3.64072" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
